import {NgModule} from '@angular/core';
import {WfConfigPage} from "./page/overview/wf-config/wf-config.page";
import {WfActivityTypePage} from "./page/overview/activity-type/activity-type.page";
import {WfIndicatorComponent} from "./component/protected-components/wf-indicator/wf-indicator.component";
import {WfTestPage} from "./page/overview/wf-test/wf-test.page";
import {WfProcessStartComponent} from "./component/protected-components/wf-process-start/wf-process-start.component";
import {WfProcessComponent} from "./component/protected-components/wf-process/wf-process.component";
import {
    WfProcessStepActivityDirective
} from "./component/protected-components/wf-process/directive/wf-process-step-activity.directive";
import {
    WfProcessStepActivityBaseComponent
} from "./component/protected-components/process-activity/wf-process-step-activity-base/wf-process-step-activity-base.component";
import {
    WfProcessStepActivityObjectComponent
} from "./component/protected-components/process-activity/wf-process-step-activity-object/wf-process-step-activity-object.component";
import {
    WfProcessStepOptionalActivityDirective
} from "./component/protected-components/wf-process/directive/wf-process-step-optional-activity.directive";
import {
    WfProcessStepOptionalActivityObjectCreateComponent
} from "./component/protected-components/process-activity/wf-process-step-optional-activity-object-create/wf-process-step-optional-activity-object-create.component";
import {
    WfProcessShowAllProcessedActivitiesComponent
} from "./component/protected-components/wf-process-show-all-processed-activities/wf-process-show-all-processed-activities.component";
import {
    WfProcessStepActivitySidePanelComponent
} from "./component/protected-components/process-activity-side/wf-process-step-activity-side-panel/wf-process-step-activity-side-panel.component";
import {
    WfProcessStepActivitySubProcessObjectComponent
} from "./component/protected-components/process-activity/wf-process-step-activity-sub-process-object/wf-process-step-activity-sub-process-object.component";
import {
    WfProcessStepActivityChooseNextStepComponent
} from "./component/protected-components/process-activity/wf-process-step-activity-choose-next-step/wf-process-step-activity-choose-next-step.component";
import {RefreshComponent} from "./component/protected-components/refresh-component/refresh.component";
import {
    WfProcessConfigOverviewComponent
} from "./component/protected-components/wf-process-config-overview/wf-process-config-overview.component";
import {
    WfProcessOutputFieldComponent
} from "./component/protected-components/wf-process-output-field/wf-process-output-field.component";
import {
    WfObjectProcessesComponent
} from "./component/protected-components/wf-object-processes/wf-object-processes.component";
import {
    WfProcessStepSideActivityObjectCreateComponent
} from "./component/protected-components/process-activity-side/wf-process-step-side-activity-object-create/wf-process-step-side-activity-object-create.component";
import {
    WfProcessStepActivitySideBaseComponent
} from "./component/protected-components/process-activity-side/wf-process-step-activity-side-base/wf-process-step-activity-side-base.component";
import {
    WfProcessStepActivitySideDirective
} from "./component/protected-components/process-activity-side/wf-process-step-activity-side.directive";
import {
    WfProcessStepActivitySideComponent
} from "./component/protected-components/process-activity-side/wf-process-step-activity-side.component";
import {
    WfProcessStepActivitySideGenericComponent
} from "./component/protected-components/process-activity-side/wf-process-step-activity-side-generic/wf-process-step-activity-side-generic.component";
import {
    WfProcessStepActivityMainComponent
} from "./component/protected-components/process-activity/wf-process-step-activity-main.component";
import {
    WfProcessStepActivityMainDirective
} from "./component/protected-components/process-activity/wf-process-step-activity-main.directive";
import {
    WfProcessStepActivityMainPanelComponent
} from "./component/protected-components/process-activity/wf-process-step-activity-main-panel/wf-process-step-activity-main-panel.component";
import {WfProcessStartProcessPage} from "./page/overview/wf-process-start-process/wf-process-start-process.page";
import {WfDashboardOverviewPage} from "./page/overview/wf-dashboard/wf-dashboard-overview.page";
import {WfProcessPage} from "./page/overview/wf-process/wf-process.page";
import {WfAnalyzePage} from "./page/overview/wf-analyze/wf-analyze.page";
import {
    WfProcessHeaderComponent
} from "./component/protected-components/wf-process/components/wf-process-header.component";
import {
    WfProcessStepActivitySearchComponent
} from "./component/protected-components/process-activity/wf-process-step-activity-search/wf-process-step-activity-search.component";
import {WfWorkflowOverviewPage} from "./page/workflow-overview-page/workflow-overview.page";
import {WfKpiComponent} from "./page/workflow-overview-page/components/kpiComponent/wf-kpi.component";
import {
    WfStatisticsComponent
} from "./page/workflow-overview-page/components/statisticsComponent/wf-statistics.component";
import {WF_ENTITY_PROVIDER} from "./wf.entity-provider";
import {CoreModule} from "../../core/core.module";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {UiModule} from "../../core/ui/ui.module";
// TODO Dependency
import {UfModule} from "../uf/uf.module";
import {BpmnEditorModule} from "../../feature-core-ext/bpmn-editor/bpmn-editor.module";
import {WF_TEST_PROVIDERS} from "./test/wf-test-definition";
import {WfProcessMonitorPage} from "./page/object/wf-process-monitor/wf-process-monitor.page";
import {
    WfProcessTimelineComponent
} from "./component/protected-components/wf-process-timeline/wf-process-timeline.component";
import {
    WfProcessStepDetailPanelComponent
} from "./component/protected-components/wf-process-step-detail-panel/wf-process-step-detail-panel.component";
import {
    WfProcessErrorDiagnosticsComponent
} from "./component/protected-components/wf-process-error-diagnostics/wf-process-error-diagnostics.component";
import {
    WfDashboardFilterComponent
} from "./component/protected-components/wf-dashboard-filter/wf-dashboard-filter.component";
import {WfInboxPage} from "./page/overview/wf-inbox/wf-inbox.page";
import {WfInboxComponent} from "./component/protected-components/wf-inbox/wf-inbox.component";
import {
    WfProcessStepActivityUfFormComponent
} from "./component/protected-components/process-activity/wf-process-step-activity-uf-form/wf-process-step-activity-uf-form.component";
import {
    WfProcessStepActivityUfFlowComponent
} from "./component/protected-components/process-activity/wf-process-step-activity-uf-flow/wf-process-step-activity-uf-flow.component";
import {WfMonitoringPage} from "./page/overview/wf-monitoring/wf-monitoring.page";
import {
    WfProcessMonitoringComponent
} from "./component/protected-components/wf-process-monitoring/wf-process-monitoring.component";
import {
    WfProcessTypeActivityConfigComponent
} from "./component/protected-components/wf-process-type-activity-config/wf-process-type-activity-config.component";
import {IconField} from "primeng/iconfield";
import {InputIcon} from "primeng/inputicon";


@NgModule({
    declarations: [
        WfConfigPage,
        WfActivityTypePage,
        WfIndicatorComponent,
        WfProcessStartComponent,
        WfProcessComponent,
        WfTestPage,
        WfProcessStepActivityDirective,
        WfProcessStepActivityBaseComponent,
        WfProcessStepActivityObjectComponent,
        WfProcessStepOptionalActivityDirective,
        WfProcessStepOptionalActivityObjectCreateComponent,
        WfProcessShowAllProcessedActivitiesComponent,
        WfProcessStepActivitySidePanelComponent,
        WfProcessShowAllProcessedActivitiesComponent,
        WfProcessStepActivitySidePanelComponent,
        WfProcessStepActivitySubProcessObjectComponent,
        WfProcessStepActivityChooseNextStepComponent,
        RefreshComponent,
        WfProcessConfigOverviewComponent,
        WfProcessOutputFieldComponent,
        WfObjectProcessesComponent,
        WfProcessStepSideActivityObjectCreateComponent,
        WfProcessStepActivityBaseComponent,
        WfProcessStepActivitySideBaseComponent,
        WfProcessStepActivitySideDirective,
        WfProcessStepActivitySideComponent,
        WfProcessStepActivitySideGenericComponent,
        WfProcessStepActivityMainComponent,
        WfProcessStepActivityMainDirective,
        WfProcessStepActivityMainPanelComponent,
        WfProcessStartProcessPage,
        WfDashboardOverviewPage,
        WfProcessPage,
        WfAnalyzePage,
        WfProcessHeaderComponent,
        WfProcessStepActivitySearchComponent,
        WfWorkflowOverviewPage,
        WfKpiComponent,
        WfStatisticsComponent,
        WfProcessMonitorPage,
        WfProcessTimelineComponent,
        WfProcessStepDetailPanelComponent,
        WfProcessErrorDiagnosticsComponent,
        WfDashboardFilterComponent,
        WfInboxPage,
        WfInboxComponent,
        WfProcessStepActivityUfFormComponent,
        WfProcessStepActivityUfFlowComponent,
        WfMonitoringPage,
        WfProcessMonitoringComponent,
        WfProcessTypeActivityConfigComponent,
    ],
    exports: [
        WfConfigPage,
        WfActivityTypePage,
        WfIndicatorComponent,
        WfProcessStartComponent,
        WfProcessComponent,
        WfTestPage,
        WfProcessStepActivityDirective,
        WfProcessStepActivityBaseComponent,
        WfProcessStepActivityObjectComponent,
        WfProcessStepOptionalActivityDirective,
        WfProcessStepOptionalActivityObjectCreateComponent,
        WfProcessShowAllProcessedActivitiesComponent,
        WfProcessStepActivitySidePanelComponent,
        WfProcessShowAllProcessedActivitiesComponent,
        WfProcessStepActivitySidePanelComponent,
        WfProcessStepActivitySubProcessObjectComponent,
        WfProcessStepActivityChooseNextStepComponent,
        RefreshComponent,
        WfProcessConfigOverviewComponent,
        WfProcessOutputFieldComponent,
        WfProcessStepSideActivityObjectCreateComponent,
        WfObjectProcessesComponent,
        WfProcessStepActivityBaseComponent,
        WfProcessStepActivitySideBaseComponent,
        WfProcessStepActivitySideDirective,
        WfProcessStepActivitySideComponent,
        WfProcessStepActivitySideGenericComponent,
        WfProcessStepActivityMainComponent,
        WfProcessStepActivityMainDirective,
        WfProcessStepActivityMainPanelComponent,
        WfProcessStartProcessPage,
        WfDashboardOverviewPage,
        WfProcessPage,
        WfAnalyzePage,
        WfProcessStepActivitySearchComponent,
        WfProcessMonitorPage,
        WfProcessTimelineComponent,
        WfProcessStepDetailPanelComponent,
        WfProcessErrorDiagnosticsComponent,
        WfDashboardFilterComponent,
        WfInboxPage,
        WfInboxComponent,
        WfProcessStepActivityUfFormComponent,
        WfProcessStepActivityUfFlowComponent,
        WfMonitoringPage,
        WfProcessMonitoringComponent,
        WfProcessTypeActivityConfigComponent,
    ],
    imports: [
        CoreModule,
        UiModule,
        UfModule,
        BpmnEditorModule,
        IconField,
        InputIcon,
    ],
    providers: [WF_ENTITY_PROVIDER, WF_TEST_PROVIDERS]
})
export class WfModule implements DynamicModule {

    alias = 'wf';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return WfKpiComponent;
    }

    getStatisticsComponent() {
        return WfStatisticsComponent;
    }

}




